<template>
  <div>
    <div class="card text-bg-warning" style="width: 100%">
      <div class="card-body">
        <h5 class="card-title text-center fs-1">Contact Us</h5>
        <div class="text-center">
          <img
            src="../assets/foto.jpeg"
            class="rounded"
            alt="..."
            style="width: 15%"
          />
        </div>
        <h5 class="card-title text-center">Raihan Hafizh</h5>
        <h5 class="card-title text-center">English Education Program</h5>
        <h5 class="card-title text-center">Institut Pendidikan Indonesia</h5>
        <h5 class="card-title text-center">
          Phone Number: +6287725051205 (Indonesia)
        </h5>
        <h5 class="card-title text-center">
          Instagram:
          <a
            href="https://www.instagram.com/thisisraihan_/"
            style="text-decoration: none; color: inherit"
            >@thisisraihan_</a
          >
        </h5>
        <h5 class="card-title text-center">
          LinkedIn:
          <a
            href="https://www.linkedin.com/in/raihanhafizh"
            style="text-decoration: none; color: inherit"
            >Raihan Hafizh</a
          >
        </h5>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FAQComp",
};
</script>
